export default __webpack_public_path__ + "static/media/icon-vacations-inverted.c98928ee.svg";